module.exports = __webpack_public_path__ + "media/images/admin/icons/phone-incoming-9a8b2ff2cf781fcc264d936f211411cf.svg";